import { render, staticRenderFns } from "./TopPensionFundsFormView.vue?vue&type=template&id=6dfdce90&scoped=true"
import script from "./TopPensionFundsFormView.vue?vue&type=script&lang=js"
export * from "./TopPensionFundsFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdce90",
  null
  
)

export default component.exports